import {get} from '../utils'

export default host => () =>
  get(`${host}/roles?order_by=level&sort_type=desc`)
  .then(response => response.json())
  .then(json => json.data)
